import React, { useCallback, useEffect, useState } from 'react';
import { Filter } from '../../../../../types/main';
import { TimesIcon } from '../../../../icon/solid';
import {
  addOrRemoveFilterValue,
  addOrRemoveFilterWithArrayValue,
  getFilterLabel,
  getFilterWithSimpleValue,
} from '../../utils';
import useStyles from './styles';

type Props = {
  filters: Filter[];
  setFilters: (filters: Filter[]) => void;
  filterLabels?: Filter[];
};

const FilterLine = ({ filters, setFilters, filterLabels }: Props) => {

  const classes = useStyles();
  const [menuLabeledFilters, setMenuLabeledFilters] = useState<Filter[]>([]);
  // filter with array split to several filters
  const [simpleFilters, setSimpleFilters] = useState<Filter[]>([]);

  useEffect(() => {
    setSimpleFilters(getFilterWithSimpleValue(filters));
  }, [filters, setSimpleFilters]);

  // update filters label after reload page
  useEffect(() => {
    if (filterLabels && filterLabels.length) {
      const updatedFilters = simpleFilters.map((f): Filter => ({
        key: f.key,
        value: f.value,
        label: getFilterLabel(f, filterLabels),
      }));

      setMenuLabeledFilters(updatedFilters);
    }
  }, [filterLabels, setMenuLabeledFilters, simpleFilters]);

  const removeFilterHandler = useCallback((filter: Filter) => {
    const menuFilter = filters.find((mf) => mf.key === filter.key);

    if (menuFilter) {
      let newFilters: Filter[] = [...filters];
      if (Array.isArray(menuFilter.value)) {
        newFilters = addOrRemoveFilterWithArrayValue(newFilters, filter.key, filter.value as string);
      } else {
        newFilters = addOrRemoveFilterValue(newFilters, filter.key, filter.value as string);
      }

      setFilters(newFilters);
    }
  }, [filters, setFilters]);

  return (
    <div className={classes.filterLine}>
      <div>
        Filter:
      </div>
      <div className={classes.tagsLine}>
        {menuLabeledFilters.map((filter) => (
          <div
            className={classes.tag}
            key={`${filter.key}-${filter.value}`}
          >
            {filter.label}
            <div>
              <div
                onClick={() => removeFilterHandler(filter)}
                className={classes.tagButton}
              >
                <TimesIcon className={classes.tagIcon} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterLine;
